var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "align-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "420px", "content-class": "new-seller-modal" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "div",
            { staticClass: "collaborators__form-dialog text-xs-center pb-5" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "close-modal",
                  attrs: { icon: "", dark: "" },
                  nativeOn: {
                    click: function($event) {
                      _vm.dialog = false
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
              _c(
                "v-card-title",
                { staticClass: "collaborators__form-title mb-2" },
                [_c("span", [_vm._v(_vm._s(_vm.modalTitle))])]
              ),
              _c("v-icon", { staticClass: "icon-new-seller mb-2" }, [
                _vm._v("icon-ic-check-1")
              ]),
              _c(
                "v-card-text",
                { staticClass: "text-xs-center collaborators__text" },
                [
                  _vm._v("Descargue el modelo, llene"),
                  _c("br"),
                  _vm._v("los datos y suba la lista")
                ]
              ),
              [
                _c(
                  "v-btn",
                  {
                    staticClass:
                      "collaborators__buttons-margin collaborators__buttons-container mb-1",
                    attrs: { outline: "", color: "primary" },
                    on: { click: _vm.downloadModelSeller }
                  },
                  [_vm._v("Descargar modelo excel")]
                ),
                _c(
                  "load-button",
                  {
                    staticClass: "collaborators__buttons-container pl-0",
                    attrs: {
                      color: "primary",
                      flat: "",
                      formats: ["xls", "xlsx"]
                    },
                    on: { change: _vm.registerUpload }
                  },
                  [_vm._v("Subir lista en excel")]
                )
              ]
            ],
            2
          )
        ]
      ),
      _c("loader", { ref: "loaderModal", attrs: { text: "Cargando" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fffc669", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fffc669","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/new-charge-seller-modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2fffc669","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/new-charge-seller-modal.vue
// module chunks = 4